var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "registrationSymbolForm",
      staticClass: "registration-symbol-form",
      attrs: {
        model: _vm.model,
        rules: _vm.rules,
        "label-width": "10em",
        "label-position": "left"
      }
    },
    [
      _vm.searchMode
        ? [
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("DateTime", {
                  attrs: {
                    prop: "ownerCode",
                    label: "検索基準日時",
                    searchCond: _vm.searchMode
                  },
                  model: {
                    value: _vm.searchBaseDate,
                    callback: function($$v) {
                      _vm.searchBaseDate = $$v
                    },
                    expression: "searchBaseDate"
                  }
                }),
                _c("Blank")
              ],
              1
            )
          ]
        : _vm.editMode
        ? [
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("DateTime", {
                  attrs: {
                    prop: "start_date",
                    label: "適用開始日時",
                    searchCond: _vm.searchMode,
                    disabled: true
                  },
                  model: {
                    value: _vm.startDate,
                    callback: function($$v) {
                      _vm.startDate = $$v
                    },
                    expression: "startDate"
                  }
                }),
                _c("DateTime", {
                  attrs: {
                    prop: "end_date",
                    label: "適用終了日時",
                    searchCond: _vm.searchMode,
                    required: true,
                    limit: "to",
                    limitDate: _vm.startDate
                  },
                  model: {
                    value: _vm.endDate,
                    callback: function($$v) {
                      _vm.endDate = $$v
                    },
                    expression: "endDate"
                  }
                })
              ],
              1
            )
          ]
        : [
            _c("DateTimeRange", {
              attrs: {
                dateTimeFrom: _vm.startDate,
                dateTimeTo: _vm.endDate,
                label: "適用期間",
                required: !_vm.searchMode,
                searchCond: _vm.searchMode
              },
              on: {
                "update:dateTimeFrom": function($event) {
                  _vm.startDate = $event
                },
                "update:date-time-from": function($event) {
                  _vm.startDate = $event
                },
                "update:dateTimeTo": function($event) {
                  _vm.endDate = $event
                },
                "update:date-time-to": function($event) {
                  _vm.endDate = $event
                }
              }
            })
          ],
      _c("el-divider"),
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("RegistrationSymbol", {
            attrs: {
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              disabled: _vm.editMode,
              autofocus: !_vm.editMode,
              "autocomplete-list": _vm.autocompleteRegistrationSymbolSet
            },
            model: {
              value: _vm.registrationSymbol,
              callback: function($$v) {
                _vm.registrationSymbol = $$v
              },
              expression: "registrationSymbol"
            }
          }),
          _c("Blank")
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("OwnerCode", {
            attrs: {
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              autofocus: _vm.editMode,
              "autocomplete-list": _vm.autocompleteOwnerCodeSet
            },
            model: {
              value: _vm.ownerCode,
              callback: function($$v) {
                _vm.ownerCode = $$v
              },
              expression: "ownerCode"
            }
          }),
          _c("ModelCode", {
            attrs: {
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              "autocomplete-list": _vm.autocompleteModelCodeSet
            },
            model: {
              value: _vm.modelCode,
              callback: function($$v) {
                _vm.modelCode = $$v
              },
              expression: "modelCode"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("AircraftType", {
            attrs: { required: !_vm.searchMode, searchCond: _vm.searchMode },
            model: {
              value: _vm.aircraftType,
              callback: function($$v) {
                _vm.aircraftType = $$v
              },
              expression: "aircraftType"
            }
          }),
          _c("AircraftAttribute", {
            attrs: {
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              initialize: true
            },
            model: {
              value: _vm.aircraftAttribute,
              callback: function($$v) {
                _vm.aircraftAttribute = $$v
              },
              expression: "aircraftAttribute"
            }
          })
        ],
        1
      ),
      _c("el-divider"),
      _vm.searchMode
        ? [
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Numeric", {
                  attrs: {
                    label: "重量1[t]",
                    prop: "weight_1",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    min: 0.1,
                    max: 999.9,
                    precision: 1,
                    step: 0.1
                  },
                  model: {
                    value: _vm.weight1,
                    callback: function($$v) {
                      _vm.weight1 = $$v
                    },
                    expression: "weight1"
                  }
                }),
                _c("Numeric", {
                  attrs: {
                    label: "騒音値1[EPNdB]",
                    prop: "noise_level_1",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    min: 0,
                    max: 999,
                    step: 1
                  },
                  model: {
                    value: _vm.noiseLevel1,
                    callback: function($$v) {
                      _vm.noiseLevel1 = $$v
                    },
                    expression: "noiseLevel1"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Numeric", {
                  attrs: {
                    label: "重量2[t]",
                    prop: "weight_2",
                    searchCond: _vm.searchMode,
                    min: 0.1,
                    max: 999.9,
                    precision: 1,
                    step: 0.1
                  },
                  model: {
                    value: _vm.weight2,
                    callback: function($$v) {
                      _vm.weight2 = $$v
                    },
                    expression: "weight2"
                  }
                }),
                _c("Numeric", {
                  attrs: {
                    label: "騒音値2[EPNdB]",
                    prop: "noise_level_2",
                    searchCond: _vm.searchMode,
                    min: 0,
                    max: 999,
                    step: 1
                  },
                  model: {
                    value: _vm.noiseLevel2,
                    callback: function($$v) {
                      _vm.noiseLevel2 = $$v
                    },
                    expression: "noiseLevel2"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Numeric", {
                  attrs: {
                    label: "重量3[t]",
                    prop: "weight_3",
                    searchCond: _vm.searchMode,
                    min: 0.1,
                    max: 999.9,
                    precision: 1,
                    step: 0.1
                  },
                  model: {
                    value: _vm.weight3,
                    callback: function($$v) {
                      _vm.weight3 = $$v
                    },
                    expression: "weight3"
                  }
                }),
                _c("Numeric", {
                  attrs: {
                    label: "騒音値3[EPNdB]",
                    prop: "noise_level_3",
                    searchCond: _vm.searchMode,
                    min: 0,
                    max: 999,
                    step: 1
                  },
                  model: {
                    value: _vm.noiseLevel3,
                    callback: function($$v) {
                      _vm.noiseLevel3 = $$v
                    },
                    expression: "noiseLevel3"
                  }
                })
              ],
              1
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Numeric", {
                  attrs: {
                    label: "重量1[t]",
                    placeholder: "0.1～999.9",
                    prop: "weight_1",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    min: 0.1,
                    max: 999.9,
                    precision: 1,
                    step: 0.1
                  },
                  model: {
                    value: _vm.weight1,
                    callback: function($$v) {
                      _vm.weight1 = $$v
                    },
                    expression: "weight1"
                  }
                }),
                _c("Numeric", {
                  attrs: {
                    label: "騒音値1[EPNdB]",
                    placeholder: "0～999",
                    prop: "noise_level_1",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    min: 0,
                    max: 999,
                    step: 1
                  },
                  model: {
                    value: _vm.noiseLevel1,
                    callback: function($$v) {
                      _vm.noiseLevel1 = $$v
                    },
                    expression: "noiseLevel1"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Numeric", {
                  attrs: {
                    label: "重量2[t]",
                    placeholder: "0.1～999.9",
                    prop: "weight_2",
                    searchCond: _vm.searchMode,
                    min: 0.1,
                    max: 999.9,
                    precision: 1,
                    step: 0.1
                  },
                  model: {
                    value: _vm.weight2,
                    callback: function($$v) {
                      _vm.weight2 = $$v
                    },
                    expression: "weight2"
                  }
                }),
                _c("Numeric", {
                  attrs: {
                    label: "騒音値2[EPNdB]",
                    placeholder: "0～999",
                    prop: "noise_level_2",
                    searchCond: _vm.searchMode,
                    min: 0,
                    max: 999,
                    step: 1
                  },
                  model: {
                    value: _vm.noiseLevel2,
                    callback: function($$v) {
                      _vm.noiseLevel2 = $$v
                    },
                    expression: "noiseLevel2"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("Numeric", {
                  attrs: {
                    label: "重量3[t]",
                    placeholder: "0.1～999.9",
                    prop: "weight_3",
                    searchCond: _vm.searchMode,
                    min: 0.1,
                    max: 999.9,
                    precision: 1,
                    step: 0.1
                  },
                  model: {
                    value: _vm.weight3,
                    callback: function($$v) {
                      _vm.weight3 = $$v
                    },
                    expression: "weight3"
                  }
                }),
                _c("Numeric", {
                  attrs: {
                    label: "騒音値3[EPNdB]",
                    placeholder: "0～999",
                    prop: "noise_level_3",
                    searchCond: _vm.searchMode,
                    min: 0,
                    max: 999,
                    step: 1
                  },
                  model: {
                    value: _vm.noiseLevel3,
                    callback: function($$v) {
                      _vm.noiseLevel3 = $$v
                    },
                    expression: "noiseLevel3"
                  }
                })
              ],
              1
            ),
            _c("el-divider"),
            _c("Remarks", {
              model: {
                value: _vm.remarks,
                callback: function($$v) {
                  _vm.remarks = $$v
                },
                expression: "remarks"
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }